<template>
  <div class="brands-pg">
    <progress-bar/>

    <!-- SEARCH BRAND -->
    <div v-if="selectedBrand === null">
      <div class="input-form">
        <div id="branch-search-group" class="form-group">
          <span class="form-input-title-label">Brands you wear</span>
          <span class="form-input-sub-label">Compare sizes with the brands you normally wear.</span>

          <selected-brands v-if="hasBrands"/>

          <input type="text"
                 v-model.trim="search"
                 class="text-input search inline"
                 placeholder="Search for a brand...">
        </div>

        <div id="brands-container">
          <overlay-spinner :active="loading" min-height="200px"/>

          <div class="no-results" v-if="!loading && !error && loadedBrands.length === 0">No results</div>

          <div class="error" v-if="error">{{ error }}</div>

          <div class="brands-grid" v-if="loadedBrands.length">
            <div class="brand-box" v-for="(brand, index) in loadedBrands" @click="selectedBrand = brand" :key="`common-brand-${index}`">
              <span class="content-centered">
                <vue-load-image>
                  <img slot="image" :src="`${appUrl}/img/brands/brand_${brand.id}.png`" :alt="brand.name">
                  <div slot="error" class="no-image">{{ brand.name }}</div>
                </vue-load-image>
              </span>
            </div>
          </div>
        </div>
      </div>

      <navigation :next-btn-text="nextBtnText"/>
    </div>

    <!-- SELECT SIZE -->
    <div class="select-size-view" v-if="selectedBrand !== null">
      <select-size :selected-brand="selectedBrand" @back="selectedBrand = null"/>
    </div>
  </div>
</template>

<script>
import ProgressBar from "../../ProgressBar";
import Navigation from "../../Navigation";
import SelectedBrands from "./brands/SelectedBrands";
import SelectSize from "./brands/SelectSize";
import {debounce} from '../../../helpers';
import {mapState, mapGetters} from 'vuex';
import OverlaySpinner from "../../OverlaySpinner";
import VueLoadImage from 'vue-load-image';

export default {
  name: "Brands",

  components: {
    VueLoadImage,
    OverlaySpinner,
    SelectSize,
    SelectedBrands,
    Navigation,
    ProgressBar,
  },

  data() {
    return {
      search: '',
      selectedBrand: null,

      loading: false,
      error: null,
    };
  },

  computed: {
    ...mapGetters({loadedBrands: 'brands/get'}),

    ...mapState('userSelections', {
      brands: 'brands',
      gender: (state) => state.general.gender,
    }),

    hasBrands() {
      return this.brands.length > 0;
    },

    nextBtnText() {
      return this.hasBrands ? 'Next' : 'Skip this step';
    },

    appUrl() {
      return process.env.VUE_APP_URL;
    },
  },

  watch: {
    search: debounce(function(query) {
      const action = (query.length === 0) ? 'brands/fetchCommon' : 'brands/search';

      this.fetchBrands(action, {
        name: query,
        gender: this.gender,
      });
    }, 500),
  },

  mounted() {
    if (!this.loadedBrands.length) {
      this.fetchBrands('brands/fetchCommon');
    }
  },

  methods: {
    fetchBrands(action, query = null) {
      this.loading = true;
      this.error = null;

      this.$store.dispatch(action, query)
        .catch(() => { this.error = "Whoops, something went wrong..."; })
        .finally(() => { this.loading = false; });
    },
  },
};
</script>
